import { render } from "./ResponsivePostsToolbar.vue?vue&type=template&id=9fdd7f60&ts=true"
import script from "./ResponsivePostsToolbar.vue?vue&type=script&lang=ts"
export * from "./ResponsivePostsToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__